//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseLayout from '@/layouts/base'
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  components: { BaseLayout },
  mixins: [
    UsesAuthenticatedUser
  ],
  data () {
    return {
      activeTab: this.$route.path,
    }
  },
}
